module.exports = __webpack_public_path__ + "img/icon.3e6350e2.png";